module.exports = __webpack_public_path__ + "img/live-android.86a28705.png";